<template>
    <div class="content-wrapper">
        <v-fade-transition mode="out-in">
            <router-view class="page-transition"></router-view>
        </v-fade-transition>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style scoped>
.content-wrapper {
    margin: 0;
    overflow-x: hidden;
    min-height: calc(100vh - 120px);
}

.page-transition {
    animation: pageLoad 0.6s ease-out;
}

@keyframes pageLoad {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
